import api from '@/libs/axiosInstance';
import type { ApiResponse } from '@fluenceur/types';
import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

export interface TeamInvitationDetails {
  email: string;
  inviteeName: string | null;
  organizationName: string;
  inviterName: string;
  brandAccesses: { brandName: string; role: string }[];
  userExists: boolean;
}

const fetchTeamInvitationDetails = async (token: string): Promise<TeamInvitationDetails> => {
  const response = await api.get<ApiResponse<TeamInvitationDetails>>(
    `/team/invitations/${token}/details`
  );

  if (response.data.success && response.data.data) {
    return response.data.data;
  }

  throw new Error(response.data.message || 'Failed to fetch invitation details');
};

export const useTeamInvitationDetails = (
  token: string | null
): UseQueryResult<TeamInvitationDetails, Error> => {
  return useQuery<TeamInvitationDetails, Error>({
    queryKey: ['team', 'invitation-details', token],
    queryFn: () => fetchTeamInvitationDetails(token!),
    enabled: !!token,
    retry: false,
  });
};
